import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Buffer } from "buffer";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";

import { Button, Col, Form, Input, Row, Modal } from "antd";

import { SaveOutlined } from "@ant-design/icons";

import { TaxOutTransferDataStates } from "./types/TaxOutTransferDataTypes";

export interface TaxOutTransferDataProps {}

class TaxOutTransferData extends Component<TaxOutTransferDataProps & any, TaxOutTransferDataStates> {
  private readonly initState!: TaxOutTransferDataStates;
  private token = new Cookies().get("_t");

  constructor(props: (TaxOutTransferDataProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      submitting: false,
      loading: false,

      dealerCode: finalDealerCode,
      orderCode: "",
      linkInvoice: "",
      user: "",
    };
    this.state = { ...this.initState };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const token = cookies.get("_t");
    if (token) {
      const user = JSON.parse(Buffer.from(cookies.get("_u"), "base64").toString());
      await this.promisedSetState({
        user: user,
      });
    }
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
    });
  };

  onStringFieldChange = <T extends keyof Pick<any, "orderCode" | "linkInvoice">>(target: T, value: any) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "orderCode":
        currentState.orderCode = value;
        break;
      case "linkInvoice":
        currentState.linkInvoice = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  onTransferData = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.orderCode) {
      Modal.error({ title: "Error", content: "Invalid Order Code" });
      return;
    }
    if (!currentState.linkInvoice) {
      Modal.error({ title: "Error", content: "Invalid Link Faktur" });
      return;
    }

    this.setState({ submitting: true });

    const data_post = {
      dealer_code: currentState.dealerCode,
      order_code: currentState.orderCode,
      link_faktur: currentState.linkInvoice,
      updated_by: currentState.user,
    };

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.transferSingleTaxOut(data_post).then(async (result) => {
        await this.promisedSetState({
          ...this.initState,
        });
        Modal.success({
          title: "Proses Sukses",
          content: "Success Transfer Data",
        });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Tax Out`}
          breadcrumbMenu={`Transfer Tax Data`}
          defaultSelectedKeys={["m-tax-out-transfer-tax-data"]}
          defaultOpenKeys={["sm-tax-out"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 8 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Form.Item style={{ paddingRight: 10 }}>
                  <i className={`text-small-grey-nopadding`}>Order Code</i>
                  <Input type="text" value={this.state.orderCode} placeholder="Order Code" onChange={(event) => this.onStringFieldChange("orderCode", event.target.value)} />
                </Form.Item>
                <Form.Item style={{ paddingRight: 10 }}>
                  <i className={`text-small-grey-nopadding`}>Link Faktur</i>
                  <Input type="text" value={this.state.linkInvoice} placeholder="Link Faktur" onChange={(event) => this.onStringFieldChange("linkInvoice", event.target.value)} />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onTransferData}>
                Transfer Data
              </Button>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(TaxOutTransferData), 50);
